import axios from 'axios';

const ApiFiles = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Cache: 'no-cache',
    NewFront: true,
  },
  responseType: 'blob',
  withCredentials: true,
});

ApiFiles.interceptors.response.use(
  async (response) => response,
  async (error) => {
    if (error.response.status === 404) {
      console.error('Não encontrado!');
    } else if (error.response.status === 500) {
      console.error('Erro! Tente novamente!');
    }
  },
);

export default ApiFiles;
